import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=4648a7e4&scoped=true"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"
import style0 from "./Autocomplete.vue?vue&type=style&index=0&id=4648a7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648a7e4",
  null
  
)

export default component.exports